import axios from "axios";
const ENDPOINT_KEY = "group";
const ENDPOINT_URI = "/group";

export default function useGroupService() {
  return {
    queryKey: ENDPOINT_KEY,
    getAllGroups: async (search = "") => {
      const params = new URLSearchParams({});
      if (search) {
        params.append("search", search);
      }
      const response = await axios.get(`${ENDPOINT_URI}/`, {
        params,
      });
      return response.data.payload;
    },
    createGroup: async ({ payload }) => {
      const response = await axios.post(`${ENDPOINT_URI}/customer`, payload);
      return response.data.payload;
    },
    addCustomersToGroup: async ({ id, payload }) => {
      const response = await axios.put(`${ENDPOINT_URI}/${id}/users`, payload);
      return response.data.payload;
    },
    removeCustomersFromGroup: async ({ id, payload }) => {
      const response = await axios.delete(`${ENDPOINT_URI}/${id}/users`, payload);
      return response.data.payload;
    },
    updateGroup: async ({ id, payload }) => {
      const response = await axios.put(`${ENDPOINT_URI}/${id}`, payload);
      return response.data.payload;
    },
    deleteGroup: async (id) => {
      const response = await axios.delete(`${ENDPOINT_URI}/${id}`);
      return response.data.payload;
    },
    getGroupById: async (id) => {
      const response = await axios.get(`${ENDPOINT_URI}/${id}`);
      return response.data.payload;
    },
  };
}
